const colors = {
  screen: '#433552',
  button: '#23AD23',
  lightButton: '#A9EEA9',
  disabled: '#696969',
  danger: 'red',
};

export default colors;
